import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
// The workshop uses the game's own fonts (styles/fonts.css), like the portal.
import "@/styles/base.css";

// A tab opened before a deploy asks for page chunks that are gone; Pages answers them with index.html, and the
// import fails ("'text/html' is not a valid JavaScript MIME type"). Reload once to pick up the new build.
window.addEventListener("vite:preloadError", (event) => {
  const key = "delve-workshop:chunk-reload";
  let last = 0;
  try { last = Number(sessionStorage.getItem(key)) || 0; } catch { /* storage blocked */ }
  if (Date.now() - last < 10_000) return; // Already reloaded just now: let the error show.
  try { sessionStorage.setItem(key, String(Date.now())); } catch { /* storage blocked */ }
  event.preventDefault();
  window.location.reload();
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
